import { Alert, AlertDescription } from '@ifixit/ui/components/alert';
import { ___p } from '@ifixit/utils/localize';
import { localizeAndFormat } from 'Shared/utils/numberFormat';
import type { GuideDependents } from './types';

/**
 * v1's strings (GuideEditLib::getPrereqEditStatusMessage), so its translations
 * carry over. It interpolates only a count and a server-built URL, so HTML is safe.
 */
export function PrereqEditNotice({
   dependents,
   className,
}: {
   dependents: GuideDependents | null;
   className?: string;
}) {
   if (!dependents) {
      return null;
   }

   const { count, url, fromOtherGuide } = dependents;
   const replacements = [
      '<strong>',
      '</strong>',
      `<a href="${url}" target="_blank" rel="noreferrer">`,
      '</a>',
      localizeAndFormat(count),
   ];
   const html = fromOtherGuide
      ? ___p(
           count,
           '%1Notice:%2 You are now editing a prerequisite to the guide you were just viewing. Any changes you make will affect %3the guide%4 that includes this step.',
           '%1Notice:%2 You are now editing a prerequisite to the guide you were just viewing. Any changes you make will affect all %3%5 guides%4 that include this step.',
           ...replacements
        )
      : ___p(
           count,
           '%1Notice:%2 You are editing a prerequisite guide. Any changes you make will affect %3the guide%4 that includes this step.',
           '%1Notice:%2 You are editing a prerequisite guide. Any changes you make will affect all %3%5 guides%4 that include this step.',
           ...replacements
        );

   return (
      <Alert role="status" variant="warning" className={className}>
         {/* The description is a grid, which would put each inline tag on its own row. */}
         <AlertDescription>
            <p dangerouslySetInnerHTML={{ __html: html }} />
         </AlertDescription>
      </Alert>
   );
}
